import {useEffect, useState} from 'react';
import { LoiFields, LoiRows } from '../../../../services/models/objs/LineOfInquirySection'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import CustomButtonSecondary from '../../../../shared/atomic_components/button/CustomButtonSecondary';
import { SegnalazioniService } from '../../../../services/controllers/segnalazioni-services/SegnalazioniService';
import { FunzionariType } from '../../../../services/models/output-objs/FunzionariOutput';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';


const ManageFunzionariLoiSection = (props : any) => {

    const [fieldsLoi, setFieldsLoi] = useState<LoiRows[]>(readStructure())
    const [loiForm, setLoiForm] = useState<{[key : string] : string}>(checkUpdate());
    const [subsectionElements, setSubsectionElements] = useState<any[]>([])
    const [funzionarioObject, setFunzionarioObject] = useState<any[]>([])
    const [assignmentType, setAssignmentType] = useState([])
    const [organigramma, setOrganigramma] = useState([])
    const segnalazioniService : SegnalazioniService = new SegnalazioniService();

    useEffect(() => {
        let catalogueList = JSON.parse(sessionStorage.getItem("catalogueList") || '{}')
        let tmpStringArrayFunz : string[] = []
        let tmpListOfAssignType: string[] = [];
        catalogueList?.funzionari?.map((singleFunz: FunzionariType) =>{
            tmpStringArrayFunz.push(singleFunz.nome + ' ' + singleFunz.cognome + ' - ' + singleFunz.unitaOrg)
        })
        let listOfFunz = tmpStringArrayFunz;
        let organigramma = catalogueList? catalogueList.funzionari : []
        let listOfAssignmentType = catalogueList? catalogueList.assignType : []
        setOrganigramma(organigramma);
        setAssignmentType(listOfAssignmentType)
        let tmpListOfFunz: string[] = [];
        if(listOfFunz) listOfFunz.map((funz : any) =>{tmpListOfFunz.push(funz)})
        if(tmpListOfAssignType) listOfAssignmentType.map((type : any) =>{tmpListOfAssignType.push(type.name)})
        fieldsLoi.map(rows => {
            rows.fields.map(field=>{
                if(field.name === 'funzionariList'){
                    field.choiceList = tmpListOfFunz
                }
                else if(field.name === 'ruoloList'){
                    field.choiceList = tmpListOfAssignType
                }
            })
        })
        const loi = props.loiUpdate
        const tmpFunzObject : any[] = [] 
        const tmpElement : any[] = [] 
        if(loi && loi.assignments && loi.assignments.length){
            loi.assignments.map((funz:any) => {
                let ruoloId = 0
                let ruoloString = ''
                if(funz.assignmentType){
                    ruoloId = funz.assignmentType.id
                    ruoloString = funz.assignmentType.name
                }                        
                let funzId = 0
                let funzName = ''
                if(funz.storOfficerId){
                    funzId = funz.storOfficerId.codUtente
                    funzName = funz.storOfficerId.nome + ' - ' + funz.storOfficerId.cognome + ' - ' + funz.storOfficerId.unitaOrg;
                }
                let singleFunz = {
                    idFunzionario: funzId,
                    idAssignment: ruoloId
                }
                let singleElement = {
                    id : funzId,
                    ruolo : ruoloString,
                    name : funzName,
                    checkSendMail : true
                }
                tmpFunzObject.push(singleFunz)
                tmpElement.push(singleElement)
            })
            setFunzionarioObject(tmpFunzObject)
            setSubsectionElements(tmpElement)
        }
    }, [])

    
    function readStructure() {
        const section = props.section;
        return section.rows
    }

    function checkUpdate() {
        const updateForm = props.loiUpdate;
        if(updateForm && updateForm['internalLoiId']){
            return updateForm
        }
        else
            return {}
    }


    function renderForm(field : LoiFields) {
        switch (field.type) {
            case "choice":
                return renderChoiceForm(field)
            case "buttonAggiungi":
                return renderButtonAssegna(field)
        }
    }

    const renderChoiceForm = (field: LoiFields) => {

        const filteredChoices =
            field.name === "ruoloList"
                ? field.choiceList!.filter(c => c !== "Osservatore") 
                : field.choiceList!;

        return (
            <FormControl fullWidth>
                <InputLabel id={`${field.name}-label`}>{field.label}</InputLabel>
                <Select
                    value={getValue(field)}
                    label={field.label}
                    onChange={(event) => {
                        HandleChange(event, field);
                    }}
                    MenuProps={{
                        PaperProps: {
                            style:{
                                maxHeight:400
                            }
                        }
                    }}
                >
                    <MenuItem key="" value="">
                        {"-Seleziona-"}
                    </MenuItem>
                    {filteredChoices?.map((choice) => (
                        <MenuItem key={choice} value={choice}>
                            {choice}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        );
    };

    const renderButtonAssegna = (field : LoiFields) => {
        return <FormControl fullWidth>
            <CustomButtonSecondary
                className='mt-2'
                id ={field.name}
                onClick={funzionarioAssign}
            >{field.label}</CustomButtonSecondary>
        </FormControl>
    }

    async function funzionarioAssign(){
        const tmpFunzObject : any[] = []
        const tmpElement : any[] = []
        Object.assign(tmpFunzObject, funzionarioObject)
        Object.assign(tmpElement, subsectionElements)
        let id = props.loiUpdate.idLoi
        if(loiForm['funzionariList'] && loiForm['ruoloList']){
            let ruoloId = 0
            assignmentType.map((role: any) =>{
                if(role.name === loiForm['ruoloList'])
                    ruoloId = role.id
            })
            let funzId = 0
            organigramma.map((funz: any) =>{
                if((funz.nome + ' ' + funz.cognome + ' - ' + funz.unitaOrg) === loiForm['funzionariList'])
                    funzId = funz.codUtente
            })
            let singleFunz = {
                idFunzionario: funzId,
                idAssignment: ruoloId,
            }
            let singleElement = {
                id : funzId,
                ruolo : loiForm['ruoloList'],
                name : loiForm['funzionariList'],
            }
            let alreadyAssigned = false
            if(subsectionElements && subsectionElements.length>0){
                subsectionElements.map((element:any) =>{
                    if(element.name === singleElement.name){
                        alreadyAssigned = true;
                        props.notificationFunctions.setErrorMessage('Il funzionario selezionato è già stato assegnato ad un ruolo')
                    }
                    if(element.ruolo === singleElement.ruolo && singleElement.ruolo === 'Referente Leader'){
                        alreadyAssigned = true;
                        props.notificationFunctions.setErrorMessage('Può essere inserito solo un referente leader per segnalazione')
                    }
                })
            }
            else if(subsectionElements.length > 2){
                alreadyAssigned = true;
                props.notificationFunctions.setErrorMessage('Il massimo numero di funziori assegnabili è 3')
            }
            if(!alreadyAssigned){
                await segnalazioniService.addFunzionarioLoi(id, singleFunz);
                tmpFunzObject.push(singleFunz)
                tmpElement.push(singleElement)
                setFunzionarioObject(tmpFunzObject)
                setSubsectionElements(tmpElement)
                const tmpLoi : {[key : string] : any} = {}
                Object.assign(tmpLoi, loiForm)
                tmpLoi['funzionari'] = tmpFunzObject
                setLoiForm(tmpLoi);
            }
        }
        else{
            props.notificationFunctions.setErrorMessage('Selezionare un funzionario e il ruolo desiderato')
        }
    }

    async function deleteSubsectionElement(element : any) {
        const tmpSubsectionElements : any[] = []
        const tmpFunzObject : any[] = []
        let ruoloId : number = 0
        switch(element.ruolo){
            case 'Referente leader': ruoloId = 1; break;
            case 'Referente': ruoloId = 2; break;
            case 'Supporto': ruoloId = 3; break;            
        }
        let id = props.loiUpdate.idLoi
        let idFunzToRemove = element.id
        await segnalazioniService.removeFunzionarioLoi(id, idFunzToRemove, ruoloId);
        subsectionElements.map(subsectionElement => {
            if (subsectionElement.id !== element.id)
                tmpSubsectionElements.push(subsectionElement)
        })
        funzionarioObject.map((singleFunz : any) =>{
            if(singleFunz.idFunzionario !== idFunzToRemove){
                tmpFunzObject.push(singleFunz)
            }
        })
        setFunzionarioObject(tmpFunzObject)
        setSubsectionElements(tmpSubsectionElements)
        const tmpLoi : {[key : string] : any} = {}
        Object.assign(tmpLoi, loiForm)
        tmpLoi['funzionari'] = tmpFunzObject
        setLoiForm(tmpLoi);
    }


    function HandleChange(event: any, field : LoiFields) {
        const tmpChange : {[key : string] : any} = {}
        Object.assign(tmpChange, loiForm)
        tmpChange[field.name] = event.target.value
        setLoiForm(tmpChange)
    }

    function getValue(field : LoiFields) : string{
        if(loiForm[field.name])
            return loiForm[field.name]
        else
            return ""
    }

    return (
        <div className="mt-2 mb-4">
            {fieldsLoi?.map(row => {
                return <div key={row.id} className="row mt-4">
                    {row.fields.map(field =>{
                        return <div key={field.name} className={"col-md-" + field.numColMd + " col-sm-12"}>
                            {renderForm(field)}
                        </div>})
                    }
                </div>})
            } 
            <div className='mt-4'>
                {subsectionElements && subsectionElements.length > 0 ? subsectionElements.map(subsectionElement => {
                    return <div key={subsectionElement.id}>
                            <div className="card-body">
                                <div className="row">
                                    <span className='col-md-5'>
                                        <strong className="margin-right-5">Nome:</strong>
                                        {subsectionElement['name']}
                                    </span>
                                    <span className='col-md-4'>
                                        <strong className="col-md-4 margin-right-5">Ruolo:</strong>
                                        {subsectionElement['ruolo']}
                                    </span>
                                    <span className="col-md-1 pointer color-delete">
                                        <DeleteOutlineOutlinedIcon onClick={() => deleteSubsectionElement(subsectionElement)}/>
                                    </span>
                                </div>
                            </div>
                        </div>
                }) : <></>}
            </div>
        </div>
    )

}


export default ManageFunzionariLoiSection;